import { createSlice } from "@reduxjs/toolkit";

export const display3DSlice = createSlice({
  name: "display3D",
  initialState: {
      display3D: false,
  },
  reducers: {
    updateDisplay3D: (state, action) => {
      state.display3D = action.payload;
    },
  },
});

export const { updateDisplay3D } = display3DSlice.actions;

export const selectDisplay3D = (state) => state.display3D.display3D;

export default display3DSlice.reducer;
